import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/empty';
import 'rxjs/add/operator/mergeMap';
import { setWorkloadSubtaskSettings } from '../../services/local-storage/index.tsx';
import { TOGGLE_INCLUDE_SUBTASKS } from '../../state/actions/workload-modal/index.tsx';
import { getIncludeSubtasks } from '../../state/selectors/workload/index.tsx';
import type { MiddlewareAPI, ActionsObservable } from '../../state/types.tsx';

export const workloadModalSubtaskToggleEpic = (action$: ActionsObservable, store: MiddlewareAPI) =>
	action$.ofType(TOGGLE_INCLUDE_SUBTASKS).flatMap(() => {
		const state = store.getState();

		const includeSubtasks = getIncludeSubtasks(state);
		setWorkloadSubtaskSettings(includeSubtasks);

		return Observable.empty<never>();
	});
